// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"904e4f9a","147":"b8c07ca1","152":"fb3a616d","466":"74e1c68b","507":"ad77a578","576":"bf7cded5","743":"7c85db3f","749":"54f03f4b","780":"5726b361","938":"c9ff3c15"}[chunkId] + ".chunk.js";
};